export default {
  back: 'Takaisin valikkoon',
  menu: 'Valikko',
};
